import Button from "../Button/Button"
import Title from "../Title/Title"

function Soc() {
  return (
    <article className="flex px-6 sm:px-5 xl:px-16 3xl:px-24 py-8 sm:py-16 bg-[--color-blue] relative">
      <div className="flex absolute left-0 top-8 sm:top-16 w-full sm:w-[calc(100%-6rem)] h-[calc(100%-2rem)] sm:h-[calc(100%-8rem)] bg-white"></div>
      {/* Responsive grid: 1 column on mobile, 2 on large screens */}
      <div className="grid grid-cols-1 lg:grid-cols-2 py-12 sm:py-24 bg-white px-0 sm:pe-5 xl:pe-16 3xl:pe-24 w-full relative z-20 gap-8 lg:gap-20 3xl:gap-80">
        {/* Sticky section in first column, sticky only on lg+ */}
        <div className="lg:sticky lg:top-64 h-fit mb-2  xl:mb-12 lg:mb-0">
          <div className="flex flex-col gap-6 sm:gap-9">
            <Title
              title="SOC as a Service (SOCaaS)"
              type="h2"
              className="uppercase text-[24px] xl:text-[60px] 2xl:text-[72px]"
            />
            <Title
              title=""
              orange="Smart Security for Agile Businesses"
              type="h4"
              className="uppercase text-[34px] 2xl:text-[48px]"
            />
            <p className="text-base sm:text-lg 2 ">
              Cyberstone&apos;s SOCaaS delivers enterprise-grade security for
              startups and mid-sized businesses in Saudi Arabia, ensuring
              compliance with SAMA and NCA regulations while eliminating the
              need for costly in-house teams.
            </p>
            <Button
              type="three"
              title="Learn More About SOCaaS"
              url="/socaas"
              icon
            />
          </div>
        </div>
        {/* Main content in second column */}
        <div className="flex flex-col">
          <div className="w-full flex flex-col">
            <Title
              title="Compliant."
              type="h2"
              className="uppercase text-[24px] xl:text-[60px] 2xl:text-[120px] leading-tight"
            />
            <Title
              title="cost-effective."
              type="h2"
              className="uppercase text-[24px] xl:text-[60px] 2xl:text-[120px] leading-tight"
            />
            <div className="flex uppercase items-center gap-2 sm:gap-4 my-8 sm:my-16">
              <span className="font-oswald text-5xl sm:text-[80px] 2xl:text-[200px] font-semibold text-[--color-brand]">
                24/7
              </span>
              <span className="text-lg sm:text-2xl 2xl:text-[48px] font-oswald font-semibold ">
                protection
              </span>
            </div>
          </div>
          {/* Responsive grid for cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-9">
            <div className="border border-[--color-gray] p-4 sm:p-6 min-h-[300px] sm:min-h-[500px] flex flex-col justify-between">
              <Title title="Continuous monitoring" type="h4" />
              <p className="flex flex-col gap-2 sm:gap-4 text-base sm:text-lg 2  ">
                <strong>Networks</strong>
                Real-time traffic analysis for anomalies.
                <strong>Endpoints</strong> Malware, ransomware, and suspicious
                activity detection. <strong>Cloud</strong> AWS, Azure, and SaaS
                platform protection.
              </p>
            </div>
            <div className="border border-[--color-gray] p-4 sm:p-6 min-h-[300px] sm:min-h-[500px] flex flex-col justify-between">
              <Title title="Proactive Threat Management" type="h4" />
              <p className="flex flex-col gap-2 sm:gap-4 text-base sm:text-lg 2 ">
                <strong>Digital Forensics</strong>
                Root-cause analysis & evidence collection.{" "}
                <strong>Threat Hunting</strong> Manual deep-dive to uncover
                hidden risks. <strong>Pen Testing</strong> Simulated attacks
                every quarter to expose weaknesses.
              </p>
            </div>
            <div className="border border-[--color-gray] p-4 sm:p-6 min-h-[200px] sm:min-h-[320px] flex flex-col justify-between col-span-1 md:col-span-2 bg-[--color-gray]">
              <Title title="Visibility & Compliance" type="h4" />
              <p className="flex flex-col gap-2 sm:gap-4 text-base sm:text-lg 2 ">
                <strong>Live Dashboards</strong>
                Track threats, response times, and system health.
                <strong>Automated Reports</strong> Ready-to-share compliance
                docs for SAMA/NCA audits.
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}

export default Soc
